import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {TextControl} from "PageBuilder/pagebuilder/Controls/ControlsList/TextControl";
import {FieldControl} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl";
import {SeparatorControl} from "PageBuilder/pagebuilder/Controls/ControlsList/SeparatorControl";
import {LinkControl} from "PageBuilder/pagebuilder/Controls/ControlsList/LinkControl";
import {FieldSummary} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldSummary";
import {EventManager} from "shared/utilities/Events/EventManager";
import {GetControl} from "InternalShared/Events/GetControl";
import {TextControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TextControl.Options";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {SeparatorControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/SeparatorControl.Options";
import {LinkControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/LinkControl.Options";
import {FieldSummaryOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldSummary.Options";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {PRControlTypes} from "../../../PageBuilderPr/PRControlFactory";
import {TableControl} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl";
import {TableControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl.Options";
import {CustomFieldControl} from "PageBuilder/pagebuilder/Controls/ControlsList/CustomFieldControl";
import {CustomFieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/CustomFieldControl.Options";


export class NormalPDFControlFactory {
    static GetControl(controlType:string):PDFControlBase
    {
        switch (controlType) {
            case ControlTypeEnum.Text:
                return new TextControl();
            case ControlTypeEnum.Field:
                return new FieldControl();
            case ControlTypeEnum.Separator:
                return new SeparatorControl();
            case ControlTypeEnum.Link:
                return new LinkControl();
            case ControlTypeEnum.Summary:
                return new FieldSummary();
            case ControlTypeEnum.Table:
                return new TableControl();
            case ControlTypeEnum.CustomField:
                return new CustomFieldControl();
            default:
               return null;
        }
    }


}

export class NormalPDFControlOptionsFactory{
    static GetControlOptions(type:string)
    {
        switch (type) {
            case ControlTypeEnum.Text:
                return new TextControlOptions();
            case ControlTypeEnum.Field:
                return new FieldControlOptions();
            case ControlTypeEnum.Separator:
                return new SeparatorControlOptions();
            case ControlTypeEnum.Link:
                return new LinkControlOptions();
            case ControlTypeEnum.Summary:
                return new FieldSummaryOptions();
            case ControlTypeEnum.Table:
                return new TableControlOptions();
            case ControlTypeEnum.CustomField:
                return new CustomFieldControlOptions();
            default:
                return null;
        }
    }


}



export enum ControlTypeEnum {
    Undefined = 'Undefined',
    Text = 'Text',
    Field = 'Field',
    Separator = 'Separator',
    Link = "Link",
    Summary = 'Summary',
    Table='Table',
    CustomField='CustomField'
}